import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { MarketdateComment } from './marketdate-comment.model';
import { MarketdateCommentPopupService } from './marketdate-comment-popup.service';
import { MarketdateCommentService } from './marketdate-comment.service';

@Component({
    selector: 'jhi-marketdate-comment-delete-dialog',
    templateUrl: './marketdate-comment-delete-dialog.component.html'
})
export class MarketdateCommentDeleteDialogComponent {

    marketdateComment: MarketdateComment;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private marketdateCommentService: MarketdateCommentService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['marketdateComment', 'commentType']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.marketdateCommentService.delete(id).subscribe((response) => {
            this.eventManager.broadcast({
                name: 'marketdateCommentListModification',
                content: 'Deleted an marketdateComment'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-marketdate-comment-delete-popup',
    template: ''
})
export class MarketdateCommentDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private marketdateCommentPopupService: MarketdateCommentPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            this.modalRef = this.marketdateCommentPopupService
                .open(MarketdateCommentDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-comment/marketdate-comment-delete-dialog.component.ts